import React from 'react';
import SVG from './SVG';

const Menu = () => (
  <SVG viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </SVG>
);

export default Menu;
